import {
  ActivityFlowProvider,
  useActivityFlowContext,
} from "./context/ActivityFlowContext";
import {
  CompletionView,
  DashboardView,
  PreferencesView,
  TaskView,
} from "@views";
import { Header, ProgressTrackerHeader } from "@components";
import "./App.css";

const AppContent = () => {
  const { currentStep } = useActivityFlowContext();

  return (
    <main className="app-shell">
      <Header />
      <ProgressTrackerHeader currentStep={currentStep} />

      {currentStep === 0 && <DashboardView />}
      {currentStep >= 1 && currentStep <= 4 && <PreferencesView />}
      {currentStep === 5 && <TaskView />}
      {currentStep === 6 && <CompletionView />}
    </main>
  );
};

export const App = () => (
  <ActivityFlowProvider>
    <AppContent />
  </ActivityFlowProvider>
);
